import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Commonmodal.css"
function Commonmodal(props) {
  const {  t  } = useTranslation();
  const { skipallProducts, showCatalogsavemodal, setShowcatalogsavemodal } =
    props;
    const [loader, setLoader] = useState(false)
  const closeCommonmodal = () => {
    setShowcatalogsavemodal(false);
  };
  const callSkipallProduct = async () =>{
    setLoader(true)
    await skipallProducts()
    setLoader(false)
  }
  return (
    <Modal show={showCatalogsavemodal} className={"commonModal_skip_all"} backdrop="static" keyboard={false}>
      <Modal.Body>{t("pages.Do you want to save the changes you have made ?")}</Modal.Body>
      <Modal.Footer>
        <button className="btn-grey btn" onClick={!loader &&closeCommonmodal}>
          {t("pages.KEEP EDITING")}
        </button>
        <button className="btn-black" onClick={() => !loader && callSkipallProduct()}>
          {
            loader?
            <Spinner size="sm" animation="border"/>
            :
            t("pages.SAVE")
          }
        </button>
      </Modal.Footer>
    </Modal>
  );
}
export default Commonmodal;
